import { fetchAllAmbassadors } from "../../apis/ambassadorApi";
import {
	requestPending,
	ambassadorSuccess,
	getSelectedAmbassador,
	requestFail,
} from "./ambassadorSlice";
import { toast } from "react-toastify";

export const ambassadorAction = () => async dispatch => {
	dispatch(requestPending());
	const data = await fetchAllAmbassadors();

	data.status === "success"
		? dispatch(ambassadorSuccess(data.ambassador))
		: toast.error(data.message) && dispatch(requestFail());
};
export const fetchSingleAmbassadorAction = _id => async dispatch => {
	if (!_id) return;

	dispatch(requestPending());

	const result = await fetchAllAmbassadors(_id);

	result.status === "success"
		? dispatch(getSelectedAmbassador(result.ambassador))
		: dispatch(requestFail(result)) && toast.error(result.message);
};
